import { useMemo } from 'react';
import { createSwrSrchV3Fetcher } from './srch-v3-infinite-util';
import { IfSrchV3Item, IfSrchV3ItemAddt, IfSrchV3Req } from './srch-v3-model';
import { useSrchV3InfiniteBase } from './useSrchV3InfiniteBase';

type SrchV3InfiniteResult<T> = {
  list: T[];
  totalCount: number;
  isLoading: boolean;
  mutate: () => void;
};

export function useApiSrchV3Infinite(
  show: boolean,
  req: IfSrchV3Req,
  fetchAddt: true
): SrchV3InfiniteResult<IfSrchV3ItemAddt>;

export function useApiSrchV3Infinite(
  show: boolean,
  req: IfSrchV3Req,
  fetchAddt?: false
): SrchV3InfiniteResult<IfSrchV3Item>;

export function useApiSrchV3Infinite(show: boolean, req: IfSrchV3Req, fetchAddt: boolean = true) {
  const fetcher = useMemo(() => createSwrSrchV3Fetcher(fetchAddt), [fetchAddt]);
  return useSrchV3InfiniteBase(show, req, fetcher, fetchAddt);
}
